import { useRef, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Package, ShieldCheck, Plug } from 'lucide-react';
import { Section, Container } from '../../ui';
import styles from './Services.module.css';

const icons = [Package, ShieldCheck, Plug];

export function Services() {
  const { t } = useTranslation('home');
  const ref = useRef<HTMLDivElement>(null);
  const [isVisible, setIsVisible] = useState(false);
  const hasAnimated = useRef(false);

  const items = t('services.items', { returnObjects: true }) as {
    title: string;
    text: string;
  }[];

  useEffect(() => {
    const node = ref.current;
    if (!node) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !hasAnimated.current) {
          hasAnimated.current = true;
          setIsVisible(true);
        }
      },
      { threshold: 0.2 }
    );
    observer.observe(node);
    return () => observer.disconnect();
  }, []);

  return (
    <Section variant="gray">
      <Container>
        <div ref={ref} className={`${styles.wrapper} ${isVisible ? styles.visible : ''}`}>
          <h2 className={styles.heading}>{t('services.heading')}</h2>

          <div className={styles.grid}>
            {items.map((item, i) => {
              const Icon = icons[i];
              return (
                <div
                  key={i}
                  className={styles.card}
                  style={{ '--service-index': i } as React.CSSProperties}
                >
                  <div className={styles.iconCircle}>
                    <Icon size={22} strokeWidth={1.5} />
                  </div>
                  <h3 className={styles.cardTitle}>{item.title}</h3>
                  <p className={styles.cardText}>{item.text}</p>
                </div>
              );
            })}
          </div>
        </div>
      </Container>
    </Section>
  );
}
